import { motion } from "framer-motion";
import { Quote } from "lucide-react";

// Placeholder testimonial text — edit once client-approved quotes are provided.
const TESTIMONIALS = [
  {
    quote:
      "United Techlab brings a rare combination: deep engineering maturity with real ownership of outcomes. They've become a trusted partner for our most critical builds.",
    name: "Girish Budhwani",
    title: "CEO",
    company: "Girman Tech",
    initials: "GB",
    accent: "green",
  },
  {
    quote:
      "They work like an elite in-house team. Verification-first isn't just a slogan here; it shows in every milestone they deliver.",
    name: "Rishabh Kanabar",
    title: "CEO",
    company: "KAI Nest",
    initials: "RK",
    accent: "cyan",
  },
  {
    quote:
      "Engineering rigor you can actually audit. United Techlab raised our bar for what a partner engagement should feel like.",
    name: "Ajat Prabha",
    title: "CTO",
    company: "fenmo",
    initials: "AP",
    accent: "green",
  },
  {
    quote:
      "From architecture reviews to AI engineering, they think about risk and correctness the way we do. A genuine force multiplier.",
    name: "Harish",
    title: "CEO",
    company: "Adrush",
    initials: "H",
    accent: "cyan",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials"
      className="relative border-b border-white/10 bg-obsidian"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-24 lg:py-28">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <div className="chip text-neon-green">&gt; /testimonials</div>
            <h2 className="mt-3 font-display font-black text-3xl md:text-4xl lg:text-5xl text-white tracking-tighter leading-tight max-w-2xl">
              What founders & engineering leaders say.
            </h2>
          </div>
          <p className="max-w-sm text-white/60 text-sm leading-relaxed">
            Real feedback from the teams we work with, all quotes reviewed and
            approved by our clients.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className={`relative border border-white/10 bg-carbon p-8 lg:p-10 group transition-colors ${
                t.accent === "green"
                  ? "hover:border-neon-green/50"
                  : "hover:border-neon-cyan/50"
              }`}
              data-testid={`testimonial-${t.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <Quote
                className={`absolute top-6 right-6 opacity-15 ${
                  t.accent === "green" ? "text-neon-green" : "text-neon-cyan"
                }`}
                size={40}
              />
              <blockquote className="text-lg leading-relaxed text-white/90 font-display">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4 pt-6 border-t border-white/10">
                <div
                  className={`h-12 w-12 flex items-center justify-center font-display font-bold text-lg ${
                    t.accent === "green"
                      ? "border border-neon-green/50 text-neon-green"
                      : "border border-neon-cyan/50 text-neon-cyan"
                  }`}
                >
                  {t.initials}
                </div>
                <div className="flex flex-col leading-tight">
                  <span className="font-display font-semibold text-white">
                    {t.name}
                  </span>
                  <span className="text-xs font-mono text-white/50">
                    {t.title} · {t.company}
                  </span>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
